import { useQuery, UseQueryResult } from "react-query";
import { ConsentDetailsResponse, getConsentDetails } from "./api";

export function useConsentDetails(params: {
  clientId: string | null;
  scope: string | null;
  state: string | null;
}): UseQueryResult<ConsentDetailsResponse, Error> {
  return useQuery(
    ["consent-details", params.clientId, params.scope, params.state],
    () => {
      if (!params.clientId || !params.scope || !params.state) {
        return Promise.reject(new Error("Missing required parameters"));
      }
      return getConsentDetails({
        clientId: params.clientId,
        scope: params.scope,
        state: params.state,
      });
    },
    {
      enabled: Boolean(params.clientId && params.scope && params.state),
      retry: false,
    }
  );
}
